import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Sign, SignService } from '../sign.service';
import { map, switchMap, filter } from 'rxjs/operators';

@Component({
  selector: 'sign-page',
  template: `<sign-viewer *ngIf="sign | async as sign" [sign]="sign"></sign-viewer>`,
  styleUrls: ['./sign-page.component.scss']
})
export class SignPageComponent implements OnInit {

  sign: Observable<Sign> = this.route.paramMap.pipe(
    map(paramMap => paramMap.get('id')),
    filter((id): id is string => id !== null),
    switchMap(signId => this.signService.getSignById(signId)),
  );

  constructor(
    private route: ActivatedRoute,
    private signService: SignService,
  ) { }

  ngOnInit() {
  }

}
